<template>
  <div
    @click="hasTooltip()"
    class="col-md-12 col-xs-12 scrollable-menu wrapper-box"
  >
    <div class="col-sm-12 remove-margins">
      <br />
      <p class="small">
        Added as Favorite
        <i
          class="fa fa-question-circle"
          style="font-size: 12px; color: orange"
          data-toggle="popover"
          data-trigger="hover"
          data-placement="top"
          data-container="body"
          data-content="Shows how many different users added you as their favorite."
        ></i
        >: <strong>{{ performanceComp.FavoriteTimes }}</strong>
      </p>
      <p class="small">
        Repeated stays
        <i
          class="fa fa-question-circle"
          style="font-size: 12px; color: orange"
          data-toggle="popover"
          data-trigger="hover"
          data-placement="top"
          data-container="body"
          data-content="Increases each time a previous client books your services again, this will increase your search ranking."
        ></i
        >: <strong>{{ performanceComp.RepeatedStays }}</strong>
      </p>
      <p
        v-if="performanceComp.AverageResponseTime"
        v-bind:class="{ 'text-danger': longAvgResponseComp }"
        class="small"
      >
        <strong>Avg Response Time</strong>
        <i
          class="fa fa-question-circle"
          style="font-size: 12px; color: orange"
          data-toggle="popover"
          data-trigger="hover"
          data-placement="top"
          data-container="body"
          data-content="The average time you take to reply or send customer a message or accept or deny a booking, please make sure to always respond as soon as possible."
        ></i
        >:<strong> {{ performanceComp.AverageResponseTime }}</strong>
      </p>
      <p v-if="!performanceComp.AverageResponseTime" class="text-success small">
        <strong>Avg Response Time </strong
        ><i
          class="fa fa-question-circle"
          style="font-size: 12px; color: orange"
          data-toggle="popover"
          data-trigger="hover"
          data-placement="top"
          data-container="body"
          data-content="The average time you take to reply or send customer a message or accept or deny a booking, please make sure to always respond as soon as possible."
        ></i
        >:<strong> no requests yet.</strong>
      </p>
      <p
        v-if="performanceComp.ResponseRate != 0"
        v-bind:class="{ 'text-danger': responseRateComp }"
        class="small"
      >
        <strong>Response Rate </strong
        ><i
          class="fa fa-question-circle"
          style="font-size: 12px; color: orange"
          data-toggle="popover"
          data-trigger="hover"
          data-placement="top"
          data-container="body"
          data-content="The percentage of booking requests you received and didn't respond to within 3 days."
        ></i
        >: <strong>{{ performanceComp.ResponseRate }}%</strong>
      </p>
      <p class="small">
        Avg Rating
        <i
          class="fa fa-question-circle"
          style="font-size: 12px; color: orange"
          data-toggle="popover"
          data-trigger="hover"
          data-placement="top"
          data-container="body"
          data-content="Average rating stars out of 5 that has been submitted by how many people."
        ></i
        >: <strong>{{ ratingComp }}</strong>
      </p>
      <p class="small">
        Profile Views
        <i
          class="fa fa-question-circle"
          style="font-size: 12px; color: orange"
          data-toggle="popover"
          data-trigger="hover"
          data-placement="top"
          data-container="body"
          data-content="Increases each time someone visits or views your public profile."
        ></i
        >: <strong>{{ performanceComp.ProfileViews }}</strong>
      </p>
      <p v-if="currentStatusComp" class="small">
        Profile Completeness
        <i
          class="fa fa-question-circle"
          style="font-size: 12px; color: orange"
          data-toggle="popover"
          data-trigger="hover"
          data-placement="top"
          data-container="body"
          data-content="This is an automated system that measures your profile for missing items, required items will show in red while optional items are shown in green."
        ></i
        >:<strong> {{ currentStatusComp }}</strong>
      </p>

      <div v-if="profileMissingInfoComp">
        <hr
          class="hidden-md hidden-lg"
          style="margin-top: 10px; margin-bottom: 10px"
        />
        <p v-if="profileMissingInfoComp.length > 0" class="small">
          Profile Pending Items
          <i
            class="fa fa-question-circle"
            style="font-size: 12px; color: orange"
            data-toggle="popover"
            data-trigger="hover"
            data-placement="top"
            data-container="body"
            data-content="Each missing item here can be added by following the link in the description."
          ></i
          >:
        </p>
        <div v-for="item in profileMissingInfoComp">
          <p v-if="item.IsRequired" class="text-danger small">
            {{ item.MissingDesc }}
            <a href="javascript:;" @click="routerGo(item.MissingLink)">{{
              item.MissingLinkDesc
            }}</a>
          </p>
          <p v-else class="text-success">
            {{ item.MissingDesc }}
            <a href="javascript:;" @click="routerGo(item.MissingLink)">{{
              item.MissingLinkDesc
            }}</a>
          </p>
        </div>
      </div>

      <button
        class="hidden-md hidden-lg btn btn-block btn-info"
        v-if="performanceComp.IsStayPreferenceSet == false"
        @click="goBookingPreference()"
      >
        <i class="fa fa-check-circle-o"></i> New (Booking Preference)
      </button>
      <button
        class="hidden-md hidden-lg btn btn-success btn-block"
        @click="goCalendar()"
      >
        <i class="fa fa-calendar"></i> Update Calendar
      </button>

      <div>
        <button
          style="margin-top: 5px"
          v-if="performanceComp.IsStayPreferenceSet == false"
          class="hidden-sm hidden-xs btn btn-lg btn-info"
          @click="goBookingPreference()"
        >
          <i class="fa fa-check-circle-o"></i> New (Booking Preference)
        </button>

        <button
          v-if="isActiveComp == false && singaporeComp == false"
          style="margin-top: 5px"
          class="btn btn-lg btn-premium hidden-sm hidden-xs"
          @click="goSubscribe()"
        >
          Go Premium <i class="fa fa-paw" />
        </button>

        <button
          v-if="isActiveComp == false && singaporeComp == false"
          style="margin-top: 5px"
          class="btn btn-lg btn-premium btn-block hidden-lg hidden-md"
          @click="goSubscribe()"
        >
          Go Premium <i class="fa fa-paw" />
        </button>

        <hr style="margin-top: 10px; margin-bottom: 10px" />
        <div class="text-center">
          <h4>Share your profile with friends and family</h4>

          <div class="center-block" style="margin-left: -4px">
            <a
              style="cursor: pointer"
              target="_top"
              href="javascript:;"
              @click="shareFacebook()"
            >
              <i id="social-fb" class="fa fa-facebook fa-3x social"></i
            ></a>
            <a style="cursor: pointer" target="_top" :href="twitterUrl">
              <i id="social-tw" class="fa fa-twitter fa-3x social"></i>
            </a>
            <a
              :disabled="!performanceComp.IsProfileReady"
              style="cursor: pointer"
              target="_top"
              :href="linkedinUrl"
              ><i id="social-ln" class="fa fa-linkedin fa-3x social"></i
            ></a>
            <a
              :disabled="!performanceComp.IsProfileReady"
              style="cursor: pointer"
              target="_top"
              :href="googleUrl"
              ><i id="social-gp" class="fa fa-google-plus fa-3x social"></i
            ></a>
            <a
              :disabled="!performanceComp.IsProfileReady"
              style="cursor: pointer"
              class="hidden-md hidden-lg"
              :href="whatsappUrl"
              data-action="share/whatsapp/share"
              ><i id="social-wa" class="fa fa-whatsapp fa-3x social"></i
            ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../../data/store.js";

const API_URL = "https://www.dupaws.com/services/";
export default {
  name: "feedback",
  data() {
    return {
      performance: "",
    };
  },
  updated() {
    this.$ga.page(this.$router);
    $('[data-toggle="popover"]').popover();
    $(".disabled").click(function (e) {
      e.preventDefault();
    });
  },
  mounted() {
    var self = this;
    $.ajax({
      type: "GET",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "bearer " + localStorage.getItem("access_token")
        );
      },
      url: API_URL + "api/sitter/dashboardPerformance",
      dataType: "json",
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        self.performance = data;
      },
      error: function (data, status, error) {
        console.log("Couldn't get myReservations list" + data.responseText);
      },
    });
  },
  methods: {
    goSubscribe: function () {
      var self = this;
      self.$router.push({ path: "/subscribe" });
      self.$router.go({ path: "/subscribe" });
    },
    hasTooltip() {
      $(function () {
        var HasTooltip = $(".hastooltip");
        HasTooltip.on("click", function (e) {
          e.preventDefault();
          var isShowing = $(this).data("isShowing");
          HasTooltip.removeData("isShowing");
          if (isShowing !== "true") {
            HasTooltip.not(this).tooltip("hide");
            $(this).data("isShowing", "true");
            $(this).tooltip("show");
          } else {
            $(this).tooltip("hide");
          }
        }).tooltip({
          animation: true,
          trigger: "manual",
        });
      });
    },
    goCalendar() {
      var self = this;
      self.$router.push({ path: "/sitter-profile-edit/calendar", force: true });
    },
    goBookingPreference() {
      var self = this;
      self.$router.push({
        path: "/sitter-profile-edit/servicerates",
        force: true,
      });
    },
    routerGo(location) {
      var self = this;
      self.$router.push({ path: location, force: true });
    },
    shareFacebook: function () {
      var self = this;
      var myQuote =
        self.performanceComp.Name + " pet sitter page on Dupaws.com";
      FB.ui(
        {
          method: "share",
          href: self.performanceComp.SitterMarketingUrl,
          quote: myQuote,
          hashtag: "#dupaws",
          mobile_iframe: true,
        },
        function (response) {
          if (response && !response.error_message) {
          } else {
          }
        }
      );
    },
  },
  computed: {
    singaporeComp: function () {
      if (store.getters.CountryData.CountryId == 9) {
        return true;
      } else {
        return false;
      }
    },
    isActiveComp: function () {
      return store.getters.SubscriptionStatus.IsActive;
    },
    whatsappUrl: function () {
      return "whatsapp://send?text=" + this.performanceComp.SitterMarketingUrl;
    },
    twitterUrl: function () {
      return (
        "https://twitter.com/share?url=" +
        this.performanceComp.SitterMarketingUrl +
        "&via=dupaws&hashtags=dupaws&text=Hey guys check out my stunning sitter profile :)"
      );
    },
    linkedinUrl: function () {
      return (
        "https://www.linkedin.com/shareArticle?mini=true&url=" +
        this.performanceComp.SitterMarketingUrl +
        "&source=LinkedIn"
      );
    },
    googleUrl: function () {
      return (
        "https://plus.google.com/share?url=" +
        this.performanceComp.SitterMarketingUrl
      );
    },
    longAvgResponseComp: function () {
      if (this.performanceComp != null) {
        if (this.performanceComp.AverageResponseSeconds > 86400) {
          return true;
        }
        return false;
      }
    },
    responseRateComp: function () {
      if (this.performanceComp != null) {
        if (this.performanceComp.ResponseRate < 65) {
          return true;
        }
        return false;
      }
    },
    profileMissingInfoComp: function () {
      if (this.profileStatusComp != null)
        if (this.profileStatusComp.ProfileMissingInfoDtos)
          return this.profileStatusComp.ProfileMissingInfoDtos;
    },
    currentStatusComp: function () {
      if (this.profileStatusComp != null)
        if (this.profileStatusComp.CurrentStatus)
          return this.profileStatusComp.CurrentStatus;
    },
    profileStatusComp: function () {
      var self = this;
      if (self.performanceComp != null)
        if (self.performanceComp.ProfileStatusDto != null)
          return self.performanceComp.ProfileStatusDto;
    },
    performanceComp: function () {
      var self = this;
      if (self.performance) return self.performance;
      return false;
    },
    ratingComp: function () {
      var self = this;
      if (
        self.performanceComp.AverageRatings > 0 &&
        self.performanceComp.RatingsCounts > 0
      ) {
        return (
          self.performanceComp.AverageRatings +
          "/5, profile has been rated " +
          self.performanceComp.RatingsCounts +
          " times"
        );
      } else return "no ratings yet";
    },
  },
};
</script>

<style scoped>
.reservation-box {
  border: #d5d5d8;
  border-style: solid;
  border-radius: 5px;
  margin-top: 10px;

  padding-bottom: 15px;
}

.scrollable-menu {
  height: auto;
  max-height: 1200px;
  overflow-x: hidden;
}

#social-fb {
  color: #3b5998;
}
#social-tw {
  color: #4099ff;
}
#social-gp {
  color: #d34836;
}
#social-ig {
  color: #974250;
}

#social-wa {
  color: #4dc85c;
}
#social-in {
  color: #0076b4;
}

.social:hover {
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -o-transform: scale(1.1);
}
.social {
  -webkit-transform: scale(0.8);
  /* Browser Variations: */

  -moz-transform: scale(0.8);
  -o-transform: scale(0.8);
  -webkit-transition-duration: 0.5s;
  -moz-transition-duration: 0.5s;
  -o-transition-duration: 0.5s;
}
</style>



// WEBPACK FOOTER //
// FeedbackAndPerformance.vue?2927b7e2